import { Input } from '@chakra-ui/react'
import { FC, useState } from 'react'

import useParametrizationSupply from '@hook/parametrization/use-supply'

import LayoutToolsButton from '../../Components/Button'
const ActionParametrizationSupplyUpload: FC = () => {
  const [isLoading, setLoading] = useState(false)

  const { postUpload } = useParametrizationSupply()

  const handleClick = () => {
    const inputValue =
      document.querySelector<HTMLInputElement>('#supply-upload')

    inputValue.value = ''
    inputValue!.click()
  }

  return (
    <>
      <LayoutToolsButton
        label="Upload de arquivo"
        isLoading={isLoading}
        loadingText="Fazendo upload"
        onClick={handleClick}
      />
      <Input
        id="supply-upload"
        d="none"
        type="file"
        accept="text/csv"
        onChange={event => {
          postUpload(event)
          setLoading(true)

          setTimeout(() => {
            setLoading(false)
          }, 2000)
        }}
      />
    </>
  )
}

export default ActionParametrizationSupplyUpload
